import { Footer } from '@leagueplatform/solutions-foundation';
import { Disclaimer } from './disclaimer-section.component';
import { useAppFooterLinks } from './use-app-footer-links.hook';

export const AppFooter = () => {
  const { footerLinks, appDownloadLinks } = useAppFooterLinks();

  return (
    <Footer
      footerLinks={footerLinks}
      footerBody={<Disclaimer />}
      appDownloadIconLinks={appDownloadLinks}
      backgroundColor="$interactiveActionPrimary"
      textColor="$onSurfaceTextReversed"
    />
  );
};
